import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import AnnotationViewContainer from 'containers/annotations/AnnotationViewContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { AdminBreadcrumb, AdminBreadcrumbItem } from 'components/atoms/AdminBreadcrumb';
import PageTitle from 'hoc/PageTitle';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { ADMINAREA_ACCESS } from 'constants/capabilities';

const ViewNotePage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer
            title={(
                <AdminBreadcrumb>
                    <AdminBreadcrumbItem to="/admin/annotations">&lt; Annotations</AdminBreadcrumbItem>
                </AdminBreadcrumb>)}
            admin hideDatePicker />}>

        <AnnotationViewContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'View Annotation' }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS] }),
)(ViewNotePage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/annotations/ViewAnnotation.js